import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { QuickbooksAccountsStyle } from "../QuickBooksAccountMapping/style";
import CustomInput from "components/CustomInput";
import NotificationProvider from "components/NotificationProvider";
import { useAddQuickBooksMappingMutation, useUpdateQuickBooksMappingMutation } from "./QuickBooksMappingSlice";
import { useState } from "react";
import { Alert } from "@mui/material";
import DropdownFilter from "components/DropdownFilter";

const AddQBMapping = ({
    open,
    setOpen,
    mappingToAdd,
    setMappingToAdd,
    mappings,
    parqEntities,
    quickbooksData,
    isEditing,
    setIsEditing,
    quickbooksKey,
    parqEntitiesKey,
    type,
    entityTitle,
    quickbooksTitle
}) => {
    const classes = QuickbooksAccountsStyle();

    const [duplicateError, setDuplicateError] = useState(false);
    const [addMapping, { isLoading: isLoadingAdd }] = useAddQuickBooksMappingMutation();
    const [editMapping, { isLoading: isLoadingEdit }] = useUpdateQuickBooksMappingMutation();

    const onChangeValue = (key, val) => {
        setMappingToAdd({ ...mappingToAdd, [key]: val })
    }

    const onCancel = () => {
        setOpen(false);
        setMappingToAdd({ entityType: type });
        setIsEditing(false);
        setDuplicateError(false);
    }

    const onSave = async () => {
        if (!validateDuplicates()) {
            setDuplicateError(true);
            return;
        }

        let result = isEditing ? await editMapping({ id: mappingToAdd?.id, quickbooksId: String(mappingToAdd?.quickbooksId), entityId: mappingToAdd?.entityId })
            : await addMapping(mappingToAdd);

        if (result && !result.error) {
            NotificationProvider.success("Mapping saved successfully");
            onCancel();
        } else {
            NotificationProvider.error("Failed to save the mapping");
        }
    }

    let valid = mappingToAdd?.entityId && mappingToAdd?.quickbooksId;

    const validateDuplicates = () => {
        let res = !mappings?.some((mapping) =>
            mapping?.entityType === mappingToAdd?.entityType &&
            mapping?.entityId === mappingToAdd?.entityId &&
            Number(mapping?.quickbooksId) === Number(mappingToAdd?.quickbooksId)
            && mapping?.id != mappingToAdd?.id
        );
        return res;
    };

    let isLoading = isLoadingAdd || isLoadingEdit;

    return (
        <Dialog open={open}>
            <DialogTitle>
                {isEditing ? "Edit Mapping" : "Add New Mapping"}
            </DialogTitle>
            <DialogContent>
                <Grid container direction='column'>
                    <Grid item xs={12} className={classes.fields}>
                        <DropdownFilter
                            title={entityTitle}
                            id="entityId"
                            value={mappingToAdd?.entityId}
                            onSelect={(val) => onChangeValue("entityId", val?.id)}
                            elementType="dropdown"
                            values={parqEntities
                                ?.map(e => ({ ...e, name: e?.[parqEntitiesKey] }))
                                ?.sort((a, b) => a.name.localeCompare(b.name))
                            }
                            withTypeAhead
                            showEmpty
                            shrink={mappingToAdd?.entityId}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.fields}>
                        <DropdownFilter
                            title={quickbooksTitle}
                            id="quickbooksId"
                            value={mappingToAdd?.quickbooksId}
                            onSelect={(val) => onChangeValue("quickbooksId", val?.id)}
                            elementType="dropdown"
                            values={quickbooksData
                                ?.map(q => ({ ...q, name: q?.[quickbooksKey] }))
                                ?.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                            }
                            withTypeAhead
                            showEmpty
                            shrink={mappingToAdd?.quickbooksId}
                            required
                        />
                    </Grid>
                </Grid>

                {duplicateError && <Alert severity='error' className={classes.alert}>
                    A mapping between these options already exists
                </Alert>}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color='primary' variant="contained">
                    Cancel
                </Button>
                <Button onClick={onSave} color='primary' variant="contained" disabled={!valid}>
                    Save
                </Button>
                {isLoading && <CircularProgress size={'1em'} />}
            </DialogActions>
        </Dialog>
    );
}

export default AddQBMapping;